import React from 'react';

export default function HorizontalSplitWithText(props) {
  return (
    <h6 className="horizontalSplit">
      {props.displayText}
    </h6>
  );
}
